import React from 'react'

const PREP_COLOR = '#3b82c4'

export function ChipSelector({ chips, selections = [], onChange, maxNoteChars = 140, disabled = false }) {
  const selectedChips = new Set(selections.map((s) => s.chip))

  function toggle(chip) {
    if (selectedChips.has(chip)) {
      onChange({ selections: selections.filter((s) => s.chip !== chip) })
    } else {
      onChange({ selections: [...selections, { chip, note: '' }] })
    }
  }

  function handleNote(chip, note) {
    onChange({ selections: selections.map((s) => s.chip === chip ? { ...s, note } : s) })
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.chips}>
        {chips.map((chip) => {
          const isSelected = selectedChips.has(chip)
          return (
            <button
              key={chip}
              style={{
                ...styles.chip,
                ...(isSelected ? { background: PREP_COLOR, borderColor: PREP_COLOR, color: '#fff' } : {}),
                ...(disabled ? styles.disabled : {}),
              }}
              onClick={() => !disabled && toggle(chip)}
              disabled={disabled}
              aria-pressed={isSelected}
            >
              {chip}
            </button>
          )
        })}
      </div>
      {selections.length > 0 && (
        <div style={styles.notes}>
          {selections.map((s) => (
            <div key={s.chip} style={styles.noteRow}>
              <span style={styles.noteLabel}>{s.chip}:</span>
              <input
                style={styles.noteInput}
                value={s.note}
                placeholder={disabled ? '' : 'Add context…'}
                maxLength={maxNoteChars}
                disabled={disabled}
                onChange={(e) => handleNote(s.chip, e.target.value)}
                aria-label={`Note for ${s.chip}`}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

const styles = {
  wrap: { padding: '10px 14px 12px', display: 'flex', flexDirection: 'column', gap: '10px' },
  chips: { display: 'flex', flexWrap: 'wrap', gap: '5px' },
  chip: {
    padding: '4px 10px', borderRadius: '12px', border: '1px solid var(--border)',
    background: 'transparent', fontSize: '11px', color: 'var(--text-secondary)',
    cursor: 'pointer', transition: 'background var(--duration-fast) ease',
  },
  disabled: { cursor: 'default', opacity: 0.7 },
  notes: { display: 'flex', flexDirection: 'column', gap: '5px' },
  noteRow: { display: 'flex', alignItems: 'center', gap: '6px' },
  noteLabel: { fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', minWidth: '70px', flexShrink: 0 },
  noteInput: {
    flex: 1, border: 'none', borderBottom: '1px solid var(--border)', outline: 'none',
    background: 'transparent', fontSize: '11px', color: 'var(--text-primary)', padding: '2px 0',
  },
}
